module.exports = __webpack_public_path__ + "img/avatar_default.85eb4d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/personal_center/avatar_default.png
// module id = uFNB
// module chunks = 16